export default __webpack_public_path__ + "static/media/misc-pantry2-768w.3a0b182a.avif";